import { map, take } from 'rxjs/operators';
import { MenuService } from '@awp/app-common';
import * as i0 from "@angular/core";
import * as i1 from "../../../../../libs/app-common/src/lib/menu.service";
var MenuResolver = /** @class */ (function () {
    function MenuResolver(menuService) {
        this.menuService = menuService;
    }
    MenuResolver.prototype.resolve = function (route, state) {
        var menuId = route.paramMap.get('menuId');
        return this.menuService.values.pipe(map(function (items) {
            var page = items.find(function (i) { return i.url === menuId; });
            if (page == null) {
                console.warn("Page '" + menuId + "' not found");
            }
            return page;
        }), take(1));
    };
    MenuResolver.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function MenuResolver_Factory() { return new MenuResolver(i0.ɵɵinject(i1.MENU_TOKEN)); }, token: MenuResolver, providedIn: "root" });
    return MenuResolver;
}());
export { MenuResolver };
